module.exports = __webpack_public_path__ + "img/odisee-logo.31f8ee42.png";